import React from 'react';
import { Link } from 'gatsby';

export const BlogTagsSide = (props) => {
	return (
		<React.Fragment>
			<aside>
				<h2>Posts by Series</h2>
				<ul>
					<li><Link to='/search/?tag=ASOIAF'>A Song of Ice and Fire</Link></li>
					<li><Link to='/search/?tag=Dunk+and+Egg'>Dunk and Egg</Link></li>
					<li><Link to='/search/?tag=Game+of+Thrones'>Game of Thrones</Link></li>
					<li><Link to='/search/?tag=House+of+the+Dragon'>House of the Dragon</Link></li>
				</ul>
			</aside>
			<aside>
				<h2>Posts by Category</h2>
				<ul>
					<li><Link to='/search/?tag=Essay'>Essay</Link></li>
					<li><Link to='/search/?tag=GRRM+Speaks'>GRRM Speaks</Link></li>
					<li><Link to='/search/?tag=Site+News'>Site News</Link></li>
				</ul>
			</aside>
		</React.Fragment>
	);
};